import { ControlCard } from "../Card/index.js";
export const FEED_ANIMATION_DURATION = 500;
export default class x {
  constructor(e, s) {
    (this.cards = e),
      (this.lastUpdated = s),
      (this.cards = e),
      (this.lastUpdated = s);
  }
  getUnreadCardCount() {
    let e = 0;
    for (const s of this.cards) s.viewed || s instanceof ControlCard || e++;
    return e;
  }
  ur() {
    throw new Error("Must be implemented in a subclass");
  }
  logCardImpressions(e) {
    throw new Error("Must be implemented in a subclass");
  }
  logCardClick(e) {
    throw new Error("Must be implemented in a subclass");
  }
  sr() {
    throw new Error("Must be implemented in a subclass");
  }
}
(x.mr = 6e4), (x.Oh = 500), (x.uo = 1e4);
